import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { needsInvitePassword } from '@/lib/passwordSetup';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (needsInvitePassword(user)) {
    return <Navigate to="/reset-password?mode=invite" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
